import {
  APPLY_QUEUED_SCAN_LABELS_TO_EIDS,
  SET_QUEUED_SCAN_LABEL_NAMES,
} from "constants/actionTypes";

export interface SetQueuedScanLabelNamesAction {
  type: typeof SET_QUEUED_SCAN_LABEL_NAMES;
  names: string[];
}

export function setQueuedScanLabelNames(
  names: string[],
): SetQueuedScanLabelNamesAction {
  return {
    type: SET_QUEUED_SCAN_LABEL_NAMES,
    names,
  };
}

export interface ApplyQueuedScanLabelsToEidsAction {
  type: typeof APPLY_QUEUED_SCAN_LABELS_TO_EIDS;
  eids: string[];
}

export function applyQueuedScanLabelsToEids(
  eids: string[],
): ApplyQueuedScanLabelsToEidsAction {
  return {
    type: APPLY_QUEUED_SCAN_LABELS_TO_EIDS,
    eids,
  };
}
